import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { SqlServerSink } from 'app/model/pipeline/copysink/sql-server.copysink';
import { sqlSinkAdapts, SqlSinkAdapter } from './sql.sink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SqlServerSink),
    asynchronous: true,
    adapts: sqlSinkAdapts
})
export class SqlServerSinkAdapter extends SqlSinkAdapter {}
